module.exports = {
  1: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  5: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  30: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  31: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  40: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  41: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  56: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  97: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  137: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  8453: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  17000: '0xCF8EbAd621778b3Ea973Dd12a15b6c90bC14bD3C',
  42161: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  43113: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  43114: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  59140: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  59144: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  80001: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  84531: '0x88d0d1a1472307d1853809c3aa455b1b76c9bcfe',
  421613: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  11155111: '0x88d0D1a1472307d1853809C3aA455B1B76c9bCfe',
  245022926: '0x5cd7B4E14d6E7879fF5260232618B924c40880D1',
}
